import { HeaderContent, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive" 
import { ContactsPrimitive, LogoPrimitive, MenuPrimitive } from "./"

export const defaultValue = [ LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.CONTACTS ]

/* Protopia Ecosystem component */ 
const HeaderPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: HeaderContent = ( props.primitive || {} ) as HeaderContent
    const getMeatByOrder = (order: number): JSX.Element => {
        const orders = primitive.orders || defaultValue
        const elementName = orders[order]
        switch( elementName ) {
            case LANDING_TYPE_CONTENT.MENU:
                return <MenuPrimitive 
                    key={LANDING_TYPE_CONTENT.MENU}
                    primitive={ {
                        ...primitive.menu,
                        text_color: primitive.logo?.text_color || primitive.text_color,
                        className: `${primitive.menu?.className || ""} order-sm-2 order-3`,
                        style: primitive.menu?.style,
                        "data-primitive-type" : LANDING_TYPE_CONTENT.MENU
                    } as any }
                />
            case LANDING_TYPE_CONTENT.LOGO:
                return <LogoPrimitive 
                    key={LANDING_TYPE_CONTENT.LOGO}
                    primitive={ {
                        ...primitive.logo,
                        text_color: primitive.logo?.text_color || primitive.text_color,
                        className: `${primitive.logo?.className || ""} order-1`,
                        style: primitive.menu?.style,
                        "data-primitive-type" : LANDING_TYPE_CONTENT.LOGO
                    } as any }
                />
            case LANDING_TYPE_CONTENT.CONTACTS:
            default:
                return <ContactsPrimitive 
                    key={LANDING_TYPE_CONTENT.CONTACTS}
                    primitive={ {
                        ...primitive.contacts,
                        text_color: primitive.contacts?.text_color || primitive.text_color,
                        className: `${primitive.contacts?.className || ""} order-sm-3 order-2`,
                        style: primitive.menu?.style,
                        "data-primitive-type" : LANDING_TYPE_CONTENT.CONTACTS
                    } as any }
                />
        }
    }
    return <div 
        className={`pe-primitive-container landing-header-primitive ${primitive.className} ${primitive.vertical ? "vertical" : ""}`} 
        style={primitive.style}
        data-primitive-type={primitive["data-primitive-type"]}
    >
        {
            ( primitive.orders || defaultValue )
            .map( (order, i: number) => getMeatByOrder(i) )
        }
        {/* <LogoPrimitive 
            primitive={ {
                ...primitive.logo,
                text_color: primitive.logo?.text_color || primitive.text_color,
                className: `${primitive.logo?.className || ""} order-1`,
                style: primitive.menu?.style,
                "data-primitive-type" : LANDING_TYPE_CONTENT.LOGO
            } as any }
        />
        <MenuPrimitive 
            primitive={ {
                ...primitive.menu,
                text_color: primitive.logo?.text_color || primitive.text_color,
                className: `${primitive.menu?.className || ""} order-sm-2 order-3`,
                style: primitive.menu?.style,
                "data-primitive-type" : LANDING_TYPE_CONTENT.MENU
            } as any }
        />
        <ContactsPrimitive 
            primitive={ {
                ...primitive.contacts,
                text_color: primitive.contacts?.text_color || primitive.text_color,
                className: `${primitive.contacts?.className || ""} order-sm-3 order-2`,
                style: primitive.menu?.style,
                "data-primitive-type" : LANDING_TYPE_CONTENT.CONTACTS
            } as any }
        /> */}
    </div>
}
export default HeaderPrimitive
 